import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { constantCase } from 'constant-case';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'translateControl'
})
export class TranslateControlPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
  }

  private getFormControlName(formControls: Record<string, AbstractControl>, translationPath: string): string {
    const formControlNames = Object.keys(formControls);
    const controlNameCandidate = translationPath.split('.').pop();
    const controlNameMatchIndex = formControlNames.findIndex((name) => constantCase(name) === controlNameCandidate);
    if (controlNameMatchIndex > -1) {
      return formControlNames[controlNameMatchIndex];
    }

    return '';
  }

  private getRequiredSymbol(formControls: Record<string, AbstractControl>, controlName: string): string {
    if (formControls[controlName]
      && formControls[controlName].validator
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      && formControls[controlName].validator('')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      && formControls[controlName].validator('').required) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return '*';
    }

    return '';
  }

  transform(
    value: string | string[],
    form: UntypedFormGroup,
    separator = ' / ',
    parameters?: Record<string, unknown>
  ): Observable<string> {
    const translationPaths: string[] = (Array.isArray(value) ? value : [value]);

    return this.translateService.get(translationPaths, parameters).pipe(
      map((translations) => Object.values(translations)
        .reduce((built: string, translation, index) => {
          const controlName = this.getFormControlName(form.controls, translationPaths[index]);
          const required = this.getRequiredSymbol(form.controls, controlName);

          return built + translation + required + separator;
        }, '')),
      map((translation) => translation.slice(0, -separator.length))
    );
  }
}
